import { createContext, useContext } from 'react';

import { IPermissionCheck } from '~/src/dash/utils/permission_service';
import { IReportingListConfig } from '~/src/dash/views/reporting/ReportingListView/config';

interface IReportingListContext {
  cfg: IReportingListConfig;
  readAuthorization: IPermissionCheck;
  writeAuthorization: IPermissionCheck;
}

export const ReportingListContext = createContext({} as IReportingListContext);
export const useReportingListStore = (): IReportingListContext => useContext(ReportingListContext);
